import { render, staticRenderFns } from "./cartItem.vue?vue&type=template&id=2d5b8b3d&"
import script from "./cartItem.vue?vue&type=script&lang=js&"
export * from "./cartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports